//gambleGame
import { Button } from "../buttonsLibrary";

import { Howl } from "howler";
import * as PIXI from "pixi.js";
import {
  createMovieClip,
  updateWinBar,
  displayeGambleGame,
  createMovieClipTexture,
} from "../../functions/Functions_General";
import { enablePlay } from "../../functions/Functions_GameBar";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { GambleNewMiniGame } from "./gambleNicoWindow";
import DeviceChecker from "../../functions/helper.ts/DeviceChecker";

export class GambleGameNico {
  // public active: boolean;
  private activeGameData: CommonData;
  private parent = new PIXI.Container();
  private gambleContainer = new PIXI.Container();
  private tictocsound: Howl;
  private success_sound: Howl;
  private fail_sound: Howl;
  private playerwin: boolean;
  private btnContainer: PIXI.Container;
  private redBtnTexture = PIXI.Texture.fromImage("redBtn.png");
  private blackBtnTexture = PIXI.Texture.fromImage("blackBtn.png");
  private grayBtnTexture = PIXI.Texture.fromImage("grayBtn.png");
  private animatedRedHighlight: PIXI.extras.AnimatedSprite;
  private animatedBlackHighlight: PIXI.extras.AnimatedSprite;
  private gambleBtnRed: Button;
  private gambleBtnBlack: Button;
  private playerPick: number;
  private boardImage: PIXI.Sprite;
  private foreGroundContainer = new PIXI.Container();

  private barImageTop: PIXI.Sprite;
  private barImageBot: PIXI.Sprite;
  private smallCardsTexture: Array<PIXI.Texture>;
  private cardsTexture: Array<PIXI.Texture>;
  private activeCard: PIXI.Sprite;
  private cardFlipTween: PIXI.tween.Tween;
  private cardmovetween: PIXI.tween.Tween;
  private cardIntween: PIXI.tween.Tween;
  private previousCardsIndex: Array<number>;
  private previousCards: Array<PIXI.Sprite> = [];
  private smallCardsContainer = new PIXI.Container();
  private smalCardsContainerNullReposition = new PIXI.Container();
  private smallCardsContainerMask: PIXI.Graphics;
  private smallCardsContainerTween: PIXI.tween.Tween;
  // public styleGolden :					PIXI.TextStyle;
  private styleWhite: PIXI.TextStyle;
  private styleWhiteSmall: PIXI.TextStyle;
  // private styleBlackBig:					PIXI.TextStyle;
  private gambleTitel: PIXI.Text;
  private gambleToWin: PIXI.Text;
  private gambleAmount: PIXI.Text;
  private previousPick: PIXI.Text;
  private labelRed: PIXI.Text;
  private labelBlack: PIXI.Text;
  private note: PIXI.Text;
  private gambleAmountDisplay: PIXI.Text;
  private gambletoWinDisplay: PIXI.Text;
  private gambleCounter: number; //gamblesLeft
  private gambleCounterDisplay: PIXI.Text;

  private allGambleWinMessage: PIXI.Text;
  private allGambleWinMessagetween: PIXI.tween.Tween;
  private currentGameCard: number;
  private flipComplet: boolean;
  private gameresultText: PIXI.Text;
  private gameresultTextTween: PIXI.tween.Tween;
  private bgLightAnimation1: PIXI.Sprite;
  private bgLightAnimation1Tween: PIXI.tween.Tween;
  private bgLightAnimation2: PIXI.Sprite;
  private bgLightAnimation2Tween: PIXI.tween.Tween;
  private mainCardScale: number;
  private gambleInfoRightContainer = new PIXI.Container();
  private redSelectTween: PIXI.tween.Tween;
  private blackSelectTween: PIXI.tween.Tween;
  private isOpen: boolean;

  private selectedImageRed: PIXI.Sprite;
  private selectedImageBlack: PIXI.Sprite;

  //-new skin
  private newGambleContainer = new PIXI.Container();
  private newGambleGame: GambleNewMiniGame;
  private logoOverlay: PIXI.Sprite;
  constructor(activeGameData: CommonData, parent: PIXI.Container) {
    this.activeGameData = activeGameData;
    //initial parameters
    this.playerwin = false; //use to see if player guessed correctly if false , after card pick animation reset , close the game
    this.currentGameCard = 0;
    this.flipComplet = false;
    this.previousCardsIndex = [0, 0, 0, 0, 0, 0];
    //create elements
    this.createSounds();
    this.createBtns();
    this.assignSounds();
    this.createMainBG();
    this.createCards();
    this.createCardsTween(); // contains also on end function listeners;
    this.createPreviousCards();
    this.createPreviousCardsMask();
    this.createTextStyle();
    this.createRedBlackBtn();
    this.createTextElements();
    this.createBGAnimationsTween();
    this.setChildrenOf(parent);

    this.createNewGambleLayout();
    //-debug
    this.startGamble(false);
    // this.startGamble(true); // hide gamble by default
    // this.parent.alpha=.5;
  }

  private createNewGambleLayout = (): void => {
    // let empty= new PIXI.Container();
    this.parent.addChild(this.newGambleContainer); //----add child for the new gamble Gamble interface
    this.newGambleContainer.y = 5;
    // this.newGambleContainer.alpha=0.5;
    this.newGambleGame = new GambleNewMiniGame(
      this.newGambleContainer,
      this.activeGameData
    );

    let btnBlackImg = this.gambleBtnBlack.getImage();
    let btnRedImg = this.gambleBtnRed.getImage();
    let boxWidth = this.newGambleGame.getFrameContainer().width / 2;
    let booxHeight = this.newGambleGame.getFrameContainer().height;
    let scaleVal = 0.75;
    let shapeBtnBlue = new PIXI.Graphics()
      .beginFill(0x0000ff, 0)
      .drawRect(0, 0, boxWidth * scaleVal - 5, booxHeight * scaleVal + 12)
      .endFill();
    btnBlackImg.addChild(shapeBtnBlue);
    shapeBtnBlue.x = -shapeBtnBlue.width / 2 - 60;
    shapeBtnBlue.y = -shapeBtnBlue.height + 75;

    let shapeBtnRed = new PIXI.Graphics()
      .beginFill(0xff0000, 0)
      .drawRect(0, 0, boxWidth * scaleVal - 5, booxHeight * scaleVal + 12)
      .endFill();
    btnRedImg.addChild(shapeBtnRed);
    shapeBtnRed.x = -shapeBtnBlue.width / 2 + 60;
    shapeBtnRed.y = -shapeBtnBlue.height + 75;

    ///--add logo overlay
    this.logoOverlay = new PIXI.Sprite(
      PIXI.Texture.fromFrame("LOGOS_english.png")
    );
    this.logoOverlay.anchor.set(0.5);
    this.logoOverlay.scale.set(1);
    this.logoOverlay.y = -35; // desktop
    this.logoOverlay.x = this.newGambleGame.getFrameContainer().width / 2 - 5;

    this.newGambleContainer.addChild(this.logoOverlay);

    //---can be woverwritten per game if necessary
    let containerGamble = this.getNewGambleParent();
    if (this.activeGameData.isMobile) {
      containerGamble.width = 1330;
      containerGamble.height = 810;
      containerGamble.x = 20;
      containerGamble.y = 5;
    } else {
      containerGamble.width = 1330;
      containerGamble.height = 810;
      containerGamble.x = 20;
      containerGamble.y = 5;
    }
  };
  public getNewGambleParent = (): PIXI.Container => {
    return this.newGambleGame.getGambleContainer();
  };
  private createTextStyle = (): void => {
    this.styleWhite = new PIXI.TextStyle({
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 30,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 40,
      align: "center",

      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    this.styleWhiteSmall = new PIXI.TextStyle({
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 20,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",

      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      // wordWrap: true,
      // wordWrapWidth: 120
    });
  };
  private createRedBlackBtn = (): void => {
    //---------------------selected btn overlay animation
    this.selectedImageRed = new PIXI.Sprite(
      PIXI.Texture.from("gambleSelected.png")
    );
    this.selectedImageBlack = new PIXI.Sprite(
      PIXI.Texture.fromFrame("gambleSelected.png")
    );
    this.selectedImageRed.anchor.set(0.5);
    this.selectedImageBlack.anchor.set(0.5);

    this.selectedImageRed.alpha = 0;
    this.selectedImageBlack.alpha = 0;
    this.gambleBtnRed.getImage().addChild(this.selectedImageRed);
    this.gambleBtnBlack.getImage().addChild(this.selectedImageBlack);

    this.redSelectTween = PIXI.tweenManager.createTween(this.selectedImageRed);
    this.redSelectTween.time = 1000;
    this.redSelectTween.easing = PIXI.tween.Easing.linear();

    this.blackSelectTween = PIXI.tweenManager.createTween(
      this.selectedImageBlack
    );
    this.blackSelectTween.time = 1000;
    this.blackSelectTween.easing = PIXI.tween.Easing.linear();

    this.redSelectTween
      .from({ scale: { x: 1, y: 1 }, alpha: 1 })
      .to({ scale: { x: 2, y: 2.4 }, alpha: 0 });
    this.blackSelectTween
      .from({ scale: { x: 1, y: 1 }, alpha: 1 })
      .to({ scale: { x: 2, y: 2.4 }, alpha: 0 });

    this.redSelectTween.loop = false;
    this.blackSelectTween.loop = false;
  };
  private createTextElements = (): void => {
    this.gambleTitel = new PIXI.Text(
      this.activeGameData.gameTextGeneral.gamble,
      this.styleWhite
    );
    this.gambleToWin = new PIXI.Text(
      this.activeGameData.gameTextGeneral.gambleToWin,
      this.styleWhiteSmall
    );
    this.gambleAmount = new PIXI.Text(
      this.activeGameData.gameTextGeneral.gambleAmount,
      this.styleWhiteSmall
    );
    this.previousPick = new PIXI.Text(
      this.activeGameData.gameTextGeneral.previousPicks,
      this.styleWhiteSmall
    );

    this.labelRed = new PIXI.Text(
      this.activeGameData.gameTextGeneral.red,
      this.styleWhite
    );
    this.labelBlack = new PIXI.Text(
      this.activeGameData.gameTextGeneral.black,
      this.styleWhite
    );
    this.note = new PIXI.Text(
      this.activeGameData.gameTextGeneral.gambleNote,
      this.styleWhiteSmall
    );

    this.gambleAmountDisplay = new PIXI.Text("0,00 EUR", this.styleWhite);
    this.gambletoWinDisplay = new PIXI.Text("0,00 EUR", this.styleWhite);

    this.gambleAmount.anchor.set(0.5, 0);
    this.gambleToWin.anchor.set(0.5, 0);
    this.gambleAmountDisplay.anchor.set(0.5, 0);
    this.gambletoWinDisplay.anchor.set(0.5, 0);

    this.gambleCounter = 5;
    this.gambleCounterDisplay = new PIXI.Text(
      this.activeGameData.gameTextGeneral.gamble +
        " " +
        this.activeGameData.gameTextGeneral.left +
        " :" +
        this.gambleCounter,
      this.styleWhiteSmall
    );
    this.gambleCounterDisplay.anchor.set(0.5);
    // this.previousPick.addChild(this.gambleCounterDisplay);

    this.allGambleWinMessage = new PIXI.Text(
      this.activeGameData.gameTextGeneral.congrats +
        "\n \n" +
        this.activeGameData.gameTextGeneral.msgFS3 +
        this.activeGameData.winValue +
        "!",
      this.styleWhite
    );
    this.allGambleWinMessagetween = PIXI.tweenManager.createTween(
      this.allGambleWinMessage
    );
    this.allGambleWinMessagetween.time = 1000;
    this.allGambleWinMessagetween.pingPong = true;
    this.allGambleWinMessagetween.loop = true;
    this.allGambleWinMessagetween.easing = PIXI.tween.Easing.linear();
    this.allGambleWinMessagetween
      .from({ scale: { x: 1, y: 1 } })
      .to({ scale: { x: 1.1, y: 1 } });

    this.gameresultText = new PIXI.Text(
      this.activeGameData.gameTextGeneral.win,
      this.styleWhite
    );
    this.gameresultText.anchor.set(0.5);
    this.gameresultTextTween = PIXI.tweenManager.createTween(
      this.gameresultText
    );
    this.gameresultTextTween.time = 500;
    this.gameresultTextTween.easing = PIXI.tween.Easing.outBack();
    this.gameresultTextTween
      .from({ alpha: 1, scale: { x: 1.5, y: 1.5 } })
      .to({ alpha: 1, scale: { x: 1, y: 1 } });
  };
  private createBGAnimationsTween = (): void => {
    this.bgLightAnimation1 = new PIXI.Sprite(
      PIXI.Texture.fromImage("gambleBGflares.png")
    );
    this.bgLightAnimation1.blendMode = PIXI.BLEND_MODES.SCREEN;
    this.bgLightAnimation1.anchor.set(0.5);
    this.bgLightAnimation1.alpha = 0.5;
    this.bgLightAnimation1Tween = PIXI.tweenManager.createTween(
      this.bgLightAnimation1
    );
    this.bgLightAnimation1Tween.time = 3000;

    this.bgLightAnimation1Tween.easing = PIXI.tween.Easing.linear();
    this.bgLightAnimation1Tween.loop = true;
    this.bgLightAnimation1Tween
      .from({ rotation: Math.PI * 2 })
      .to({ rotation: 0 });

    this.bgLightAnimation2 = new PIXI.Sprite(
      PIXI.Texture.fromImage("gambleBGflares.png")
    );
    this.bgLightAnimation2.blendMode = PIXI.BLEND_MODES.SCREEN;
    this.bgLightAnimation2.anchor.set(0.5);
    this.bgLightAnimation2.alpha = 0.5;
    this.bgLightAnimation2Tween = PIXI.tweenManager.createTween(
      this.bgLightAnimation2
    );
    this.bgLightAnimation2Tween.time = 3000;
    this.bgLightAnimation2Tween.easing = PIXI.tween.Easing.linear();
    this.bgLightAnimation2Tween.loop = true;
    this.bgLightAnimation2Tween
      .from({ rotation: 0 })
      .to({ rotation: Math.PI * 2 });
  };
  private createSounds = (): void => {
    //make tiktok

    this.tictocsound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/tictoc.m4a?" + "version=" + this.activeGameData.gameVersion,
      ],
      volume: 0.8,
      // loop:true,
      // preload:true,
      sprite: {
        // music: [0, 20869,true],
        toc: [230, 200, false],
      },
    });

    this.success_sound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/23566057_success.m4a?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 0.1,
      sprite: {
        success: [50, 1100, false],
      },
    });

    this.fail_sound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/24395766_wrongPick.m4a?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 0.1,
      sprite: {
        fail: [0, 1900, false],
      },
    });

    this.activeGameData.soundList.push(this.fail_sound);
    this.activeGameData.soundList.push(this.success_sound);
    this.activeGameData.soundList.push(this.tictocsound);
  };
  private createBtns = (): void => {
    //create animated  overlya for btn
    this.animatedRedHighlight = createMovieClip("blackBtn", 0, 22);
    this.animatedRedHighlight.x = 0;
    this.animatedRedHighlight.y = 0;
    this.animatedRedHighlight.anchor.set(0.5);
    this.animatedRedHighlight.alpha = 0.5;
    this.animatedRedHighlight.loop = false;
    this.animatedBlackHighlight = createMovieClip("blackBtn", 0, 22);
    this.animatedBlackHighlight.x = 0;
    this.animatedBlackHighlight.y = 0;
    this.animatedBlackHighlight.anchor.set(0.5);
    this.animatedBlackHighlight.alpha = 0.5;
    this.animatedBlackHighlight.loop = false;
    this.isOpen = false;
    this.animatedBlackHighlight.animationSpeed = 1.2;
    this.animatedRedHighlight.animationSpeed = 1.2;

    //create btn
    this.gambleBtnRed = new Button(
      new PIXI.Sprite(this.redBtnTexture)
      // new PIXI.Rectangle(-175, -50, 350, 100)
    ); // fix hitbox
    this.gambleBtnBlack = new Button(
      new PIXI.Sprite(this.blackBtnTexture)
      // new PIXI.Rectangle(-175, -50, 350, 100)
    ); // fix hitbox
    let btnBlackImg = this.gambleBtnBlack.getImage();
    let btnRedImg = this.gambleBtnRed.getImage();

    //add highlight to the btn
    btnRedImg.addChild(this.animatedRedHighlight);
    btnBlackImg.addChild(this.animatedBlackHighlight);
  };
  private assignSounds = (): void => {
    this.animatedBlackHighlight.onComplete = () => {
      this.animatedRedHighlight.gotoAndPlay(0);
      this.activeGameData.MobileBtns.setGambleHighLight(0);
      // console.log("playRed")
      this.playTikTok(true);
    };

    this.animatedRedHighlight.onComplete = () => {
      this.animatedBlackHighlight.gotoAndPlay(0);
      this.activeGameData.MobileBtns.setGambleHighLight(1);
      // console.log("playBlack")
      this.playTikTok(true);
    };
  };
  private createCards = (): void => {
    //smallcards
    this.smallCardsTexture = [];
    this.smallCardsTexture[0] = PIXI.Texture.fromImage("cardBacksmall.png");
    this.smallCardsTexture[1] = PIXI.Texture.fromImage("red1small.png"); //diamondred
    this.smallCardsTexture[2] = PIXI.Texture.fromImage("black1small.png"); //clubs//black
    this.smallCardsTexture[3] = PIXI.Texture.fromImage("red2small.png"); //hearts//red
    this.smallCardsTexture[4] = PIXI.Texture.fromImage("black2small.png"); //spade black
    //bigcard for active game

    this.cardsTexture = [];
    this.cardsTexture[0] = PIXI.Texture.fromImage("cardBack.png");
    this.cardsTexture[1] = PIXI.Texture.fromImage("red1.png");
    this.cardsTexture[2] = PIXI.Texture.fromImage("black1.png");
    this.cardsTexture[3] = PIXI.Texture.fromImage("red2.png");
    this.cardsTexture[4] = PIXI.Texture.fromImage("black2.png");
    //visible card;
    this.activeCard = new PIXI.Sprite(this.cardsTexture[0]);
    this.activeCard.scale.set(2);
  };
  private createMainBG = (): void => {
    this.boardImage = new PIXI.Sprite(PIXI.Texture.fromImage("gambleBG.png"));
    this.boardImage.addChild(this.foreGroundContainer);
    this.mainCardScale = 1.3;
    this.barImageTop = new PIXI.Sprite(
      PIXI.Texture.fromImage("gambleLines.png")
    );
    this.barImageBot = new PIXI.Sprite(
      PIXI.Texture.fromImage("gambleLines.png")
    );
  };
  private createCardsTween = (): void => {
    //create a tween for the card  --goes to 1 to -1 when  value smaller than 0 change carde texture;
    this.cardFlipTween = PIXI.tweenManager.createTween(this.activeCard);
    this.cardFlipTween
      .from({ scale: { x: -this.mainCardScale } })
      .to({ scale: { x: this.mainCardScale } });
    this.cardFlipTween.time = 250;
    this.cardFlipTween.easing = PIXI.tween.Easing.linear();

    this.cardFlipTween.chain(this.cardmovetween);

    this.cardFlipTween.on(
      "end",
      function(_sprite: PIXI.Sprite, self: GambleGameNico) {
        self.cardFlipTween.reset();
        self.cardmovetween.reset();
        self.cardmovetween.start();
        self.newGambleGame.updateHisory();
        self.gambleCounterDisplay.text =
          self.activeGameData.gameTextGeneral.gambleLeft +
          ": " +
          self.gambleCounter;

        if (self.playerwin) {
          self.gameresultText.text = self.activeGameData.gameTextGeneral.win;
          self.cardmovetween.delay = 500;
          self.newGambleGame.displayWinLose(true);
        } else {
          self.gameresultText.text = self.activeGameData.gameTextGeneral.lose;
          self.cardmovetween.delay = 2000;
          self.newGambleGame.displayWinLose(false);
        }
        self.gameresultText.alpha = 0;
        self.gameresultTextTween.reset();
        self.gameresultTextTween.start();
      }.bind(this.cardFlipTween, this.activeCard, this)
    );
    this.cardmovetween = PIXI.tweenManager.createTween(this.activeCard);
    this.cardmovetween.time = 4500;
    this.cardmovetween.delay = 1000;
    this.cardmovetween.easing = PIXI.tween.Easing.inBack();
    this.cardmovetween
      .from({
        x: this.boardImage.width / 2,
        scale: { x: this.mainCardScale, y: this.mainCardScale },
        alpha: 1,
      })
      .to({
        x: this.boardImage.width / 2 + 300,
        scale: { x: 0.125, y: 0.125 },
        alpha: 0,
      });
    //when the move animation is complete the card texture is reset to card's back texture ;
    this.cardmovetween.on(
      "end",
      function(
        sprite: PIXI.Sprite,
        self: GambleGameNico,
        displayeGambleGame: Function
      ) {
        sprite.texture = self.cardsTexture[0];
        self.cardIntween.reset();
        self.cardIntween.reset();
        if (self.playerwin && self.gambleCounter > 0) {
          self.cardIntween.start();
        } else if (self.playerwin && self.gambleCounter <= 0) {
          //after winning all the gambles counters , autocloses

          self.activeGameData.jumpCoin.startJump();
          self.gambleEndDisplay(displayeGambleGame);
          // updateWin(self.activeGameData);

          if (self.activeGameData.freeSpinsActive) {
            self.activeGameData.freeSpinMode.setMessageDisplay();
          } else {
            if (self.activeGameData.isTournament == false) {
              // &&activeGameData.InspectReplay==false   )
              //request new balance only on normal game
              self.activeGameData.requestNewBalance(self.activeGameData);
            }
          }
        } else {
          // END OF GAMBLE GAME WITH LOSING CARD close the gamblegame when player picked wrong card -
          displayeGambleGame(false, self.activeGameData);
          self.gameresultText.alpha = 0;
          self.gameresultTextTween.stop();
          // jackpotWinCheck(self.activeGameData);
        }

        self.previousCards[0].texture =
          self.smallCardsTexture[self.currentGameCard];
        self.smallCardsContainerTween.reset();
        self.smallCardsContainerTween.start();

        self.gameresultText.alpha = 0;
        self.gameresultTextTween.stop();
        self.newGambleGame.updateHisory();
      }.bind(this.cardmovetween, this.activeCard, this, displayeGambleGame)
    );

    //when card appars in center
    this.cardIntween = PIXI.tweenManager.createTween(this.activeCard);
    this.cardIntween.time = 400;
    this.cardIntween.easing = PIXI.tween.Easing.outBack();
    this.cardIntween
      .from({
        x: this.boardImage.width / 2,
        scale: { x: -0.5, y: 0.5 },
        alpha: 0,
      })
      .to({
        x: this.boardImage.width / 2,
        scale: { x: -this.mainCardScale, y: this.mainCardScale },
        alpha: 1,
      });

    this.cardIntween.on(
      "end",
      function(_sprite: PIXI.Sprite, self: GambleGameNico) {
        self.cardFlipTween.reset();
        self.cardmovetween.reset();
        self.cardFlipTween.stop();
        self.cardmovetween.stop();
        // self.activeCard.position.set(self.boardImage.width/2,self.boardImage.height/2);//reset position of card  just incase

        if (self.playerwin) {
          // player can reclick on black or red Button
          self.enableGambleBlackandRedButtoms(true);
        } else {
          self.gameresultText.alpha = 0;
          self.gameresultTextTween.stop();
          // close the bonus game
        }
      }.bind(this.cardIntween, this.activeCard, this)
    );
  };
  public onResize = (): void => {
    this.updateBtnVisibility();
  };
  private createPreviousCards = (): void => {
    for (var i = 0; i < this.previousCardsIndex.length; i++) {
      this.previousCards[i] = new PIXI.Sprite(
        this.smallCardsTexture[this.previousCardsIndex[i]]
      );
      // console.log(this.previousCardsIndex[i])
      this.previousCards[i].x = this.previousCards[i].width * i + 10 * i;
      this.smallCardsContainer.addChild(this.previousCards[i]);
    }
  };
  private createPreviousCardsMask = (): void => {
    this.smallCardsContainerMask = new PIXI.Graphics();
    this.smallCardsContainerMask.beginFill(0x00ffff);
    this.smallCardsContainerMask.drawRect(
      0,
      0,
      this.previousCards[0].width * 5 + 5 * 10,
      this.previousCards[0].height
    );
    this.smallCardsContainerMask.alpha = 0.5;

    // this.previousCards[0].alpha=.5
    this.smallCardsContainer.mask = this.smallCardsContainerMask;
    this.smallCardsContainerTween = PIXI.tweenManager.createTween(
      this.smallCardsContainer
    );
    this.smallCardsContainerTween.time = 500;
    this.smallCardsContainerTween.easing = PIXI.tween.Easing.outBack();

    //when the move animation is complete the card texture is reset to card's back texture

    this.smallCardsContainerTween.on(
      "end",
      function(_sprite: PIXI.Sprite, self: GambleGameNico) {
        // this.reset();/

        self.smallCardsContainerTween.reset();
        for (var i = self.previousCards.length - 1; i > 0; i--) {
          self.previousCards[i].texture = self.previousCards[i - 1].texture;
        }

        self.smallCardsContainer.x -= self.previousCards[0].width + 10; //self.boardImage.width / 2 + 150;
        // console.log('resetposition')
      }.bind(this.smallCardsContainerTween, this.smallCardsContainer, this)
    );
  };

  private gambleEndDisplay = (displayeGambleGame: Function): void => {
    this.allGambleWinMessage.alpha = 1;
    this.allGambleWinMessage.text =
      this.activeGameData.gameTextGeneral.congrats +
      "\n \n" +
      this.activeGameData.gameTextGeneral.msgFS3 +
      ": " +
      this.activeGameData.winValue.getDisplayValue() +
      "" +
      this.activeGameData.currency +
      "!";
    this.allGambleWinMessagetween.start();
    this.showGambleInfos(false);
    this.playTikTok(false);
    // this.activeGameData.gameBar.playBtnMode===0;

    //change btn to Play btn bc player winning has been collected alredy
    this.activeGameData.gameBar.setPlayButtonIndex(0); //playButtom(0)//change icon once collected
    // this.activeGameData.gameBar.playBtnMode = 0;
    this.activeGameData.winValue.value = 0; //resetWinlinevalue since player already took win
    // this.activeGameData.playable=true;

    let closeTicker = new PIXI.ticker.Ticker();
    closeTicker.start();
    let closeTickerTimer = Date.now();
    closeTicker.add((_delta: number) => {
      if (Date.now() - closeTickerTimer > 3000) {
        displayeGambleGame(false, this.activeGameData);
        closeTicker.stop();
        closeTicker.destroy();

        this.activeGameData.freeSpinMode.setMessageDisplay();

        // displayeGambleGame(false,this.activeGameData);
        this.gameresultText.alpha = 0;
        this.gameresultTextTween.stop();
      }
    });
  };

  // updatePreviousCards() {
  // 	for (var i = 0; i < this.previousCardsIndex.length; i++) {

  // 		this.previousCards[i].texture = this.smallCardsTexture[this.previousCardsIndex[i]];
  // 	}
  // }

  private setChildrenOf(parent: PIXI.Container) {
    parent.addChild(this.parent);

    this.parent.addChild(this.boardImage);
    this.boardImage.alpha = 0;

    this.foreGroundContainer.addChild(this.gambleContainer);
    // this.boardImage.addChild(this.gambleContainer);

    this.boardImage.position.set(
      parent.width / 2 - this.boardImage.width / 2,
      parent.height / 2 - this.boardImage.height / 2 - 8
    );

    // this.gambleContainer.addChild(this.bgLightAnimation1);
    this.bgLightAnimation1.position.set(
      this.boardImage.width / 2,
      this.boardImage.height / 2
    );
    // this.gambleContainer.addChild(this.bgLightAnimation2);
    this.bgLightAnimation2.position.set(
      this.boardImage.width / 2,
      this.boardImage.height / 2
    );

    // this.gambleContainer.addChild(this.barImageTop);
    // this.boardImage.addChild(this.barImageBot);
    this.barImageTop.scale.set(0.9, -0.9);
    this.barImageTop.position.set(
      this.boardImage.width / 2 - this.barImageTop.width / 2,
      this.boardImage.height / 2 - this.barImageTop.height / 2 - 200 + 12 - 50
    );
    this.barImageBot.scale.set(0.9);
    this.barImageBot.position.set(
      this.boardImage.width / 2 - this.barImageBot.width / 2,
      this.boardImage.height / 2 - this.barImageBot.height / 2 + 200 - 20
    );

    // this.gambleContainer.addChild(this.gambleTitel);
    this.gambleTitel.anchor.set(0.5);
    this.gambleTitel.position.set(
      this.boardImage.width / 2,
      this.boardImage.height / 2 - 240 - 35
    );

    // this.gambleContainer.addChild(this.gambleToWin);
    this.gambleToWin.position.set(
      this.boardImage.width * 0.8,
      this.boardImage.height / 2 - this.gambleToWin.height / 2 - 175 - 50
    );

    // this.gambleContainer.addChild(this.gambleAmount);
    this.gambleAmount.position.set(
      this.boardImage.width * 0.2,
      this.boardImage.height / 2 - this.gambleToWin.height / 2 - 175 - 50
    );

    this.btnContainer = new PIXI.Container();
    this.gambleContainer.addChild(this.btnContainer);

    this.gambleBtnRed.placeButton(this.btnContainer, [
      this.boardImage.width / 2 - 320,
      this.boardImage.height / 2 + 230 + 20,
    ]);
    this.gambleBtnBlack.placeButton(this.btnContainer, [
      this.boardImage.width / 2 + 320,
      this.boardImage.height / 2 + 230 + 20,
    ]);

    let btnBlackImg = this.gambleBtnBlack.getImage();
    let btnRedImg = this.gambleBtnRed.getImage();

    btnBlackImg.addChild(this.labelBlack);
    btnRedImg.addChild(this.labelRed);

    this.labelBlack.position.set(-this.labelBlack.width / 2, -15);
    this.labelRed.position.set(-this.labelRed.width / 2, -15);
    // this.labelBlack.position.set(this.gambleBtnBlack.image.width/2-this.labelRed.width/2,this.gambleBtnBlack.image.width/2-this.labelRed.height/2);

    // this.gambleContainer.addChild(this.gameresultText);
    this.gameresultText.position.set(
      this.boardImage.width / 2,
      this.boardImage.height - this.gameresultText.height * 2
    );
    // this.gameresultText.anchor.set(.5)
    this.gameresultText.alpha = 0;

    // this.gambleContainer.addChild(this.activeCard);
    this.activeCard.anchor.set(0.5);

    this.activeCard.position.set(
      this.boardImage.width / 2,
      this.boardImage.height / 2
    );

    // this.gambleContainer.addChild(this.smalCardsContainerNullReposition);
    // this.gambleContainer.addChild(this.gambleInfoRightContainer);
    this.gambleInfoRightContainer.addChild(
      this.smalCardsContainerNullReposition
    );
    this.smalCardsContainerNullReposition.addChild(this.smallCardsContainer);

    this.smallCardsContainer.position.set(50, 0);
    //     // this.boardImage.width / 2 + 150,
    //     // this.boardImage.height / 2 - this.smallCardsContainer.height
    // );
    this.gambleInfoRightContainer.addChild(this.previousPick);
    this.gambleInfoRightContainer.addChild(this.gambleCounterDisplay);
    this.previousPick.anchor.set(0.5);

    this.smalCardsContainerNullReposition.addChild(
      this.smallCardsContainerMask
    );

    // this.gambleInfoRightContainer.x=0//this.gambleBtnBlack.getPosX();

    this.previousPick.position.set(this.smallCardsContainer.width / 4, 0);
    this.gambleCounterDisplay.position.set(this.previousPick.position.x, 100);

    this.smallCardsContainerMask.position.set(
      this.smallCardsContainer.x + this.previousCards[0].width + 5,
      this.smallCardsContainer.y
    );

    // this.gambleContainer.addChild(this.note);
    this.note.anchor.set(0.5);
    this.note.position.set(
      this.boardImage.width / 2 - 300,
      this.note.height / 2 + 240
    );
    this.note.scale.set(0.8);

    this.gambleInfoRightContainer.position.set(
      this.boardImage.width * 0.75,
      this.gambleInfoRightContainer.height / 2 + 240
    );

    this.previousPick.scale.set(0.8);
    // this.gambleCounterDisplay.scale.set(0.8);

    // this.gambleContainer.addChild(this.gambleAmountDisplay);
    // this.gambleContainer.addChild(this.gambletoWinDisplay);

    this.gambleAmountDisplay.position.set(this.boardImage.width * 0.2, 40);
    this.gambletoWinDisplay.position.set(
      this.boardImage.width * 0.8,
      this.gambleAmountDisplay.y
    );

    this.gambleBtnRed.setFunction(this.playerpicked.bind(this, 0));

    this.gambleBtnBlack.setFunction(this.playerpicked.bind(this, 1));

    this.activeGameData.MobileBtns.setFunctionGambleBtn(
      0,
      this.playerpicked.bind(this, 0)
    );
    this.activeGameData.MobileBtns.setFunctionGambleBtn(
      1,
      this.playerpicked.bind(this, 1)
    );

    this.gambleContainer.addChild(this.allGambleWinMessage);
    this.allGambleWinMessage.anchor.set(0.5);
    this.allGambleWinMessage.position.set(
      this.boardImage.width / 2,
      this.boardImage.height / 2
    );

    this.parent.alpha = 0;

    if (this.activeGameData.isMobile) {
      this.boardImage.scale.set(this.activeGameData.gameScale);
      // this.boardImage.position.set((parent.width / 2 - this.boardImage.width / 2), (parent.height / 2 - this.boardImage.height / 2) - 70);
      // this.smallCardsContainer.position.set(
      //   this.boardImage.width / 2 + 150,
      //   this.boardImage.height / 2 - this.smallCardsContainer.height * 1.5
      // );
      this.smallCardsContainerMask.position.set(
        this.smallCardsContainer.x + this.previousCards[0].width + 5,
        this.smallCardsContainer.y
      );
      this.smallCardsContainerTween.from({ x: this.smallCardsContainer.x }).to({
        x: this.smallCardsContainer.x + this.previousCards[0].width + 10,
      });

      this.parent.y = 140;
    } else {
      this.boardImage.scale.set(this.activeGameData.cardsize / 213);

      //fullscreenGamble

      // this.smallCardsContainer.position.set(
      //   this.gambleBtnBlack.getPosX()-125,this.boardImage.height / 2 - this.smallCardsContainer.height * 1.5
      // );

      this.smallCardsContainerMask.position.set(
        this.smallCardsContainer.x + this.previousCards[0].width + 5,
        this.smallCardsContainer.y
      );
      this.smallCardsContainerTween.from({ x: this.smallCardsContainer.x }).to({
        x: this.smallCardsContainer.x + this.previousCards[0].width + 10,
      });

      //this.smallCardsContainer.y + this.previousPick.height * 2.2
      // );
      // console.log(this.smallCardsContainer.x)

      //adjust position of samll card to left
      // this.gambleInfoRightContainer.x = -30; //-this.previousCards[0].width + 10;

      this.parent.y = 140; //slight adjustments on desktop;
    }
    this.smalCardsContainerNullReposition.x =
      -this.smalCardsContainerNullReposition.width / 2 - 25;
    this.smalCardsContainerNullReposition.y = 20;

    this.boardImage.position.set(0, 0);

    this.setPositiontoCenter(); //.x=this.activeGameData.size[0]/2-this.boardImage.width/2;
    this.setFullscreenMode();
  }

  private setFullscreenMode() {
    if (this.activeGameData.displayOptionSmall == false) {
      this.parent.scale.set(1);
      this.boardImage.scale.set(1.59, 1.25);
      this.boardImage.alpha = 0.5;
      this.boardImage.x = 0; //(Math.abs(scaleAfter-scaleBefore/2))//-267;
      this.boardImage.y = -75;
      if (this.activeGameData.isMobile) {
        this.boardImage.y = -30;
      }
      let newScale =
        1 * (1 / this.boardImage.scale.x) * this.boardImage.scale.y;
      this.gambleContainer.scale.set(newScale, 1);
      this.gambleContainer.x =
        this.activeGameData.size[0] / 2 - this.boardImage.width / 2 - 12; //(this.boardImage.width)*newScale// 0//this.gambleContainer.width*newScale;
      this.setPositiontoCenter();
    }
  }

  public getBgImage = (): PIXI.Sprite => {
    return this.boardImage;
  };

  public setPositiontoCenter = (): void => {
    this.parent.x = this.activeGameData.size[0] / 2 - this.boardImage.width / 2;
  };
  public setWidth = (): void => {
    // this.boardImage.width=newVal;
    // this.parent.width
  };

  private loadPreviousCard = (): void => {
    let gambleHistory = this.activeGameData.betResponse.gameContext.contextData
      .gambleHistory;
    // gambleHistory=[0,1,2,3]///test
    let lengthToRead = gambleHistory.length;
    if (lengthToRead > 5) {
      lengthToRead = 5;
    }

    for (var i = 0; i < lengthToRead; i++) {
      let newCardTexture = this.smallCardsTexture[gambleHistory[i] + 1];
      if (this.activeGameData.replay.isOpen()) {
        newCardTexture = this.smallCardsTexture[gambleHistory[i + 1] + 1];
      }
      this.previousCards[i + 1].texture = newCardTexture; //this.previousCards[gambleHistory[i]+1];
    }
    this.newGambleGame.updateHisory();
  };
  // public changeTextureCardsback=(textureBig:PIXI.Texture,textureSmall:PIXI.Texture):void=>
  // {
  //   this.cardsTexture[0] = textureBig;
  //     this.smallCardsTexture[0]= textureSmall;
  //     this.smallCardsTexture[0] = PIXI.Texture.fromImage("cardBacksmallVTK.png");

  // }
  private updateGambleValues = (): void => {
    //  console.log('GAMBLE VALUE===',this.activeGameData.winValue.getDisplayValue())//.getDisplayValue()
    if (this.activeGameData.betResponse != undefined) {
      this.gambleCounter = this.activeGameData.betResponse.gameContext.contextData.gamblesLeft;
    }
    // console.log(this.gambleCounter)
    if (this.gambleCounter > 0) {
      this.gambletoWinDisplay.text =
        (
          2 * parseFloat(this.activeGameData.winValue.getDisplayValue())
        ).toFixed(2) +
        " " +
        this.activeGameData.currency;

      // console.log(this.gambletoWinDisplay.text,this.activeGameData.winValue.getDisplayValue())
      this.gambleAmountDisplay.text =
        this.activeGameData.winValue.getDisplayValue() +
        " " +
        this.activeGameData.currency;
    } else {
      this.gambletoWinDisplay.text =
        this.activeGameData.winValue.getDisplayValue() +
        " " +
        this.activeGameData.currency;
      this.gambleAmountDisplay.text =
        this.activeGameData.winValue.getDisplayValue() +
        " " +
        this.activeGameData.currency;
    }

    this.newGambleGame.updateGambleAmount(
      this.gambleAmountDisplay.text,
      this.gambletoWinDisplay.text
    );
    // console.log( this.gambletoWinDisplay.text)
    updateWinBar(false, this.activeGameData); //
  };

  private enableButtoms = (bool: boolean): void => {
    this.enableGambleBlackandRedButtoms(bool);

    if (bool) {
      this.bgLightAnimation1Tween.start();
      this.bgLightAnimation2Tween.start();
    } else {
      this.bgLightAnimation1Tween.stop();
      this.bgLightAnimation2Tween.stop();
    }

    // this.activeGameData.MobileBtns.se
  };

  private showGambleInfos = (bool: boolean): void => {
    let alphaValue = 0;
    if (bool === true) {
      alphaValue = 1;
    }
    this.gambleBtnBlack.setAlpha(alphaValue);
    this.gambleBtnRed.setAlpha(alphaValue);

    this.activeGameData.MobileBtns.setGambleVisible(bool);

    this.smallCardsContainer.alpha = alphaValue;
    this.note.alpha = alphaValue;
    this.previousPick.alpha = alphaValue;
    this.gambleAmount.alpha = alphaValue;
    this.gambleToWin.alpha = alphaValue;
  };

  private enableGambleBlackandRedButtoms = (bool: boolean): void => {
    if (this.activeGameData.replayMode) {
      this.gambleBtnRed.setInteractive(false);
      this.gambleBtnBlack.setInteractive(false);
    } else {
      this.gambleBtnRed.setInteractive(bool);
      this.gambleBtnBlack.setInteractive(bool);
    }

    // 		this.gambleBtnRed.settMode(bool);
    // this.gambleBtnBlack.setMode(bool);
    this.activeGameData.MobileBtns.setGambleActive(bool);

    if (bool) {
      if (this.parent.alpha != 0) {
        this.gambleBtnRed.setNewTexture(this.redBtnTexture);
        this.gambleBtnBlack.setNewTexture(this.blackBtnTexture);
        this.animatedRedHighlight.play();
        this.playTikTok(true);

        // this.animatedBlackHighlight.play();
        this.animatedRedHighlight.alpha = 0.5;
        this.animatedBlackHighlight.alpha = 0.5;
      }
    } else {
      this.gambleBtnRed.setNewTexture(this.grayBtnTexture);
      this.gambleBtnBlack.setNewTexture(this.grayBtnTexture);
      this.playTikTok(false);
      this.animatedRedHighlight.stop();
      this.animatedBlackHighlight.stop();
      this.animatedRedHighlight.alpha = 0;
      this.animatedBlackHighlight.alpha = 0;
    }
    this.newGambleGame.enableBtnClickable(bool);
  };

  private playerpicked = (pick: number): void => {
    // console.log('PICK',pick)
    this.activeGameData.MobileBtns.setGambleBtnClicked(pick);
    if (pick == 0) {
      this.redSelectTween.reset();
      this.redSelectTween.start();
    } else {
      this.blackSelectTween.reset();
      this.blackSelectTween.start();
    }
    this.playerPick = pick;
    //disable the buttons

    enablePlay(false, this.activeGameData);
    //request  card from server
    //once request complete
    //start flip Animation
    this.enableGambleBlackandRedButtoms(false);

    // this.activeCard.texture=this.cardsTexture[3]

    if (this.activeGameData.replayMode == false) {
      this.activeGameData.serverAction = this.activeGameData.API_handler.getServerActionGamble(); // this.activeGameData.API_handler.serverAction[2];
      let gambleData = {
        // session_id: this.activeGameData.token,
        action: this.activeGameData.serverAction,
        value: this.playerPick,
      };
      let self = this;

      this.activeGameData.API_handler.GetGamePlayResult(
        gambleData,
        this.successPickCallBack.bind(self),
        this.failPickCallBack.bind(self)
      );
    } else {
      //for replay autopick
      this.successPickCallBack(this.activeGameData.betResponse);
    }
  };

  private successPickCallBack = (data: any): void => {
    // console.log("SUCCESS REQUEST")
    this.activeGameData.betResponse = data;
    this.gambleCounter = this.activeGameData.betResponse.gameContext.contextData.gamblesLeft;
    this.currentGameCard =
      this.activeGameData.betResponse.gameContext.contextData.gambleHistory[0] +
      1;
    this.cardResponse();
    enablePlay(true, this.activeGameData);
    this.activeGameData.setAllowedInputs(this.activeGameData);
  };
  private failPickCallBack = (): void => {
    // error on gamble
    this.activeGameData.callBackFailMessage(6);
    this.activeGameData.disableAllBtns(this.activeGameData);
  };

  private playerRightPick = (): void => {
    let winamount = this.activeGameData.betResponse.gameContext.contextData.win
      .credits.amount;
    // console.log(winamount)
    this.activeGameData.winValue.updateValue(winamount);

    this.success_sound.play("success");
    this.playerwin = true;
  };
  private playerWrongPick = (): void => {
    this.playerwin = false;
    this.fail_sound.play("fail");
    this.activeGameData.winValue.updateValue(0);
    this.activeGameData.activePlaying = false;
    // console.log("wrong color picked");
  };

  private cardResponse = (): void => {
    // console.log(this.playerPick,this.currentGameCard)
    let playerWin: boolean = false;

    switch (this.playerPick) {
      case 0:
        if (this.currentGameCard === 1 || this.currentGameCard == 3) {
          this.playerRightPick();
          playerWin = true;
        } else {
          this.playerWrongPick();
          playerWin = false;
        }
        break;
      case 1:
        if (this.currentGameCard === 2 || this.currentGameCard == 4) {
          this.playerRightPick();
          playerWin = true;
        } else {
          this.playerWrongPick();
          playerWin = false;
          //check free spin message to display
          this.activeGameData.freeSpinMode.setMessageDisplay();
        }
        break;
    }
    this.cardFlip();
    this.updateGambleValues();
    //--new gamble

    this.newGambleGame.onSelect(playerWin, this.playerPick);
  };

  private cardFlip = (): void => {
    this.flipComplet = false;
    this.cardFlipTween.on(
      "update",
      function(
        _sprite: PIXI.Sprite,
        self: GambleGameNico,
        elapsedTime: number
      ) {
        if (elapsedTime > 0.5 && self.flipComplet === false) {
          self.activeCard.texture = self.cardsTexture[self.currentGameCard];
          self.flipComplet = true;
        }
      }.bind(this.cardFlipTween, this.activeCard, this)
    );
    this.cardFlipTween.reset();
    this.cardFlipTween.start();
    // console.log(s)
  };

  private playTikTok = (bool: boolean): void => {
    if (bool && this.activeGameData.replayMode == false) {
      // this.tictocsound.stop();
      // this.tictocsound.play("toc");
      if (this.tictocsound.playing()) {
        this.tictocsound.stop();
      }
      this.tictocsound.play("toc");
    } else {
      this.tictocsound.stop();
    }
  };

  //public
  public getGambleVisibility = (): boolean => {
    // var vOut = this.parent.alpha != 0 ? true : false;

    // return vOut;

    return this.isOpen;
  };

  // public isGambleOpen=():boolean=>
  // {
  //   return this.isOpen;
  // }

  public setReplayPick = (): void => {
    let cardNames = ["DIAMONDS", "CLUBS", "HEARTS", "SPADES"];
    let cardColors = ["RED", "BLACK"];
    let playerInputCard = this.activeGameData.betResponse.gameContext
      .contextData.gambleInput; //color
    let gambleResult = this.activeGameData.betResponse.gameContext.contextData
      .gambleResult; //card
    this.currentGameCard = cardNames.indexOf(gambleResult) + 1;
    this.playerpicked(cardColors.indexOf(playerInputCard));
  };
  private portraitLayout = (): void => {
    this.activeGameData.MobileBtns.setGambleVisible(true);
    this.btnContainer.scale.set(1); //make btn invisible and unclickable
    this.gambleTitel.scale.set(2);
    this.gambleAmount.scale.set(1.5);
    this.gambleToWin.scale.set(1.5);
    this.previousPick.scale.set(1.2);
    this.gambleCounterDisplay.scale.set(1.2);
    this.note.scale.set(1.2);

    this.logoOverlay.y = -60;
    console.log("port", this.logoOverlay.y);
  };
  private landscapeLayout = (): void => {
    // set visible inframe gamble btn
    this.activeGameData.MobileBtns.setGambleVisible(false);
    this.btnContainer.scale.set(1);
    this.gambleTitel.scale.set(1);
    this.gambleAmount.scale.set(1);
    this.gambleToWin.scale.set(1);
    this.previousPick.scale.set(0.8);
    this.note.scale.set(0.8);
    this.gambleCounterDisplay.scale.set(1);

    if (this.activeGameData.isMobile) {
      this.logoOverlay.y = -35;
    }

    //  console.log("land",this.logoOverlay.y)
  };

  public updateBtnVisibility = (): void => {
    if (
      this.activeGameData.playOnPortrait &&
      this.parent.alpha == 1 &&
      this.gambleBtnRed.getImage().alpha == 1 &&
      this.activeGameData.isMobile
    ) {
      if (window.matchMedia("(orientation: portrait)").matches) {
        let screenRatio = window.innerHeight / window.innerWidth;

        if (screenRatio >= this.activeGameData.minRatioForPortraitPlay) {
          this.portraitLayout();
        } else {
          //ratio not enough so display desktop layout;
          this.landscapeLayout();
        }
      } else {
        // set visible inframe gamble btn
        this.landscapeLayout();
      }
    }

    //check the upperlimit

    this.checkUpperLimitWidth(300, this.previousPick);
    this.checkUpperLimitWidth(300, this.gambleCounterDisplay);
    this.checkUpperLimitWidth(300, this.note);
  };
  // /--modding the gamble game look
  public setStyleCardBackTexture = (newCardImageName: string): void => {
    //
    //--update big and small cards back texture   with same name but add Small on small card
    this.cardsTexture[0] = PIXI.Texture.fromFrame(newCardImageName + ".png");

    for (var i = 0; i <= this.smallCardsTexture.length; i++) {
      if (
        this.smallCardsTexture[0].textureCacheIds[0] ==
        this.previousCards[i].texture.textureCacheIds[0]
      ) {
        this.previousCards[i].texture = PIXI.Texture.fromFrame(
          newCardImageName + "small.png"
        );
      }
    }
    this.cardsTexture[0] = PIXI.Texture.fromFrame(newCardImageName + ".png");

    this.smallCardsTexture[0] = PIXI.Texture.fromFrame(
      newCardImageName + "small.png"
    );
  };

  public setStyleCardFrontTexture = (
    newCardImageNameList: Array<string>
  ): void => {
    //---NOTE
    //Name array porder : diamond red   //clubs black  //hearts red   //spade black
    //-Array images names must be in following order and  only require the name of big image , small image should have same name as big image ending wih "small"

    this.cardsTexture[1] = PIXI.Texture.fromFrame(
      newCardImageNameList[0] + ".png"
    );
    this.smallCardsTexture[1] = PIXI.Texture.fromFrame(
      newCardImageNameList[0] + "small.png"
    );

    this.cardsTexture[2] = PIXI.Texture.fromFrame(
      newCardImageNameList[1] + ".png"
    );
    this.smallCardsTexture[2] = PIXI.Texture.fromFrame(
      newCardImageNameList[1] + "small.png"
    );

    this.cardsTexture[3] = PIXI.Texture.fromFrame(
      newCardImageNameList[2] + ".png"
    );
    this.smallCardsTexture[3] = PIXI.Texture.fromFrame(
      newCardImageNameList[2] + "small.png"
    );

    this.cardsTexture[4] = PIXI.Texture.fromFrame(
      newCardImageNameList[3] + ".png"
    );
    this.smallCardsTexture[4] = PIXI.Texture.fromFrame(
      newCardImageNameList[3] + "small.png"
    );
  };

  public setButtonFlashAnimationSpeed = (newSpeed: number): void => {
    this.animatedBlackHighlight.animationSpeed = newSpeed;
    this.animatedRedHighlight.animationSpeed = newSpeed;
  };

  public setStyleSelectTexture = (newTexturename: string): void => {
    this.selectedImageRed.texture = PIXI.Texture.from(newTexturename + ".png");
    this.selectedImageBlack.texture = PIXI.Texture.from(
      newTexturename + ".png"
    );
  };
  public setNewSoundTick = (
    soundNameWithExtension: string,
    soundStart: number,
    soundDuration: number,
    playSpeed: number
  ): void => {
    this.tictocsound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/" +
          soundNameWithExtension +
          "?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 0.8,
      sprite: {
        toc: [soundStart, soundDuration, false],
      },
    });
    //define the speed in which the button animation   swap
    this.setButtonFlashAnimationSpeed(playSpeed);
  };

  public setNewSoundWin = (
    soundNameWithExtension: string,
    soundStart: number,
    soundDuration: number
  ): void => {
    this.success_sound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/" +
          soundNameWithExtension +
          "?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 0.8,
      sprite: {
        success: [soundStart, soundDuration, false],
      },
    });
  };

  public setNewSoundLose = (
    soundNameWithExtension: string,
    soundStart: number,
    soundDuration: number
  ): void => {
    this.fail_sound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/" +
          soundNameWithExtension +
          "?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 0.8,
      sprite: {
        fail: [soundStart, soundDuration, false],
      },
    });
  };

  // public setBGOverlay=(bgOverlayName:string,screenBlendingMode:boolean=false,wraptoFill:boolean=true):void=>
  // {
  //   //
  //   //--update big and small cards back texture   with same name but add Small on small card

  //   let  newOverlay=new PIXI.Sprite(PIXI.Texture.fromFrame(bgOverlayName+".png"));
  //   if(screenBlendingMode==true)
  //   {
  //     newOverlay.blendMode=PIXI.BLEND_MODES.SCREEN;
  //   }
  //   if(wraptoFill)
  //   {
  //     newOverlay.width=  this.boardImage.width/2;
  //     newOverlay.height=  this.boardImage.height/2;
  //   }
  //   this.boardImage.addChild(newOverlay);
  // }
  public setStyleSpinningImage = (
    newImagename: string,
    scale: number = 1,
    imageAlpha: number = 0.5
  ): void => {
    this.bgLightAnimation1.texture = PIXI.Texture.fromFrame(
      newImagename + ".png"
    );
    this.bgLightAnimation2.texture = PIXI.Texture.fromFrame(
      newImagename + ".png"
    );
    this.bgLightAnimation1.alpha = imageAlpha;
    this.bgLightAnimation2.alpha = imageAlpha;
    this.bgLightAnimation1.scale.set(scale);
    this.bgLightAnimation2.scale.set(scale);
  };

  public setBGTexture = (newImagename: string): void => {
    let test = new PIXI.Sprite(PIXI.Texture.fromImage(newImagename + ".png"));
    //  test.width=this.boardImage.width
    this.boardImage.addChild(test);
  };

  public setStyleNewBtnImage = (
    blackImage: string,
    RedImage: string,
    GrayImage: string,
    overlayAnimationName: string,
    animationTotalFrames: number = 22
  ): void => {
    // by default total frame is 22
    ///--
    this.blackBtnTexture = PIXI.Texture.fromImage(blackImage + ".png");
    this.redBtnTexture = PIXI.Texture.fromImage(RedImage + ".png");
    this.grayBtnTexture = PIXI.Texture.fromImage(GrayImage + ".png");
    this.animatedRedHighlight.textures = createMovieClipTexture(
      overlayAnimationName,
      0,
      animationTotalFrames
    );
    this.animatedBlackHighlight.textures = createMovieClipTexture(
      overlayAnimationName,
      0,
      animationTotalFrames
    );
    ///--updates the texture for portrait mode

    this.activeGameData.MobileBtns.setStyleNewBtnImage(
      blackImage,
      RedImage,
      GrayImage,
      overlayAnimationName,
      animationTotalFrames
    );
  };

  //-- end of modding

  public checkUpperLimitWidth = (lim: number, text: PIXI.Text): void => {
    if (text.width > lim) {
      text.width = lim;
    }
  };
  public startGamble = (bool: boolean): void => {
    //--handle the buybonus visibility while gamble is visible
    if (this.activeGameData.BuyBonus != undefined) {
      this.newGambleGame.setVisible(bool);
      if (bool) {
        //hide it
        this.activeGameData.BuyBonus.enableBuyBonusIfAllowed(false);
        this.activeGameData.BuyBonus.setHidden(true);
      } else {
        //unhide it
        console.log("CLOSE GAMBLE GAME");
        this.activeGameData.BuyBonus.setHidden(false);
        let isAllowedToBuyBonus =
          this.activeGameData.loginResponse.gameSettings.defaultAllowedInputActions.indexOf(
            this.activeGameData.API_handler.getServerActionBUY_BONUS()
          ) >= 0;
        this.activeGameData.BuyBonus.enableBuyBonusIfAllowed(
          isAllowedToBuyBonus
        );
      }
    }
    //-- resume game  default function
    this.isOpen = bool;
    let alphaValue = 0;
    if (bool === true) {
      alphaValue = 1;
      this.activeGameData.winAnimation.stop();
    }
    this.parent.alpha = alphaValue;
    this.enableButtoms(bool);
    this.updateGambleValues();

    this.allGambleWinMessage.alpha = 0;
    this.allGambleWinMessagetween.stop();
    //if open
    if (bool) {
      this.activeCard.texture = this.cardsTexture[0];
      this.animatedRedHighlight.play();
      // this.playTikTok(true);

      this.gambleCounter = 5;
      if (this.activeGameData.betResponse != undefined) {
        this.gambleCounter = this.activeGameData.betResponse.gameContext.contextData.gamblesLeft;
        // console.log('new Value',this.gambleCounter)
      }
      this.gambleCounterDisplay.text =
        this.activeGameData.gameTextGeneral.gambleLeft +
        ": " +
        this.gambleCounter;

      this.loadPreviousCard();
    } else {
      this.animatedRedHighlight.gotoAndStop(0);
      this.animatedBlackHighlight.gotoAndStop(0);
      this.allGambleWinMessagetween.stop();
      this.playTikTok(false);
      // this.tictocsound.mute(true);
    }

    this.enableGambleBlackandRedButtoms(bool);
    // this.playerwin=true;
    this.cardIntween.reset();
    this.cardIntween.start();

    this.showGambleInfos(bool);

    this.updateBtnVisibility();
  };

  public resetAndRecenterGambleWithFixedRatio = (): void => {
    // allows to recenter and reset the scaling to the original ratio without having it stretching
    this.foreGroundContainer.scale.y =
      this.boardImage.scale.x / this.boardImage.scale.y;
    let heightDiffrence = this.boardImage.scale.y - this.boardImage.scale.x;
    this.foreGroundContainer.y = (this.boardImage.height * heightDiffrence) / 4;
  };

  public getRatioFixContainer = (): PIXI.Container => {
    return this.foreGroundContainer;
  };

  public getParent = (): PIXI.Container => {
    return this.parent;
  };
}
